export default "__VITE_PUBLIC_ASSET__0a987116__"